module.exports = __webpack_public_path__ + "media/images/xpass/icons/xpass-token-icon-df491314ec687732b3bbe1ef01ef3c8d.png";